<div class="my-4 bg-card shadow rounded-2xl p-4">
    <fuse-alert
        class="my-4"
        *ngIf="showAlertCargar"
        [dismissed]="!showAlertCargar"
        [dismissible]="true"
        [appearance]="'outline'"
        [showIcon]="true"
        [type]="alertCargar.type"
        [@shake]="alertCargar.type === 'error'">
        {{ alertCargar.message }}
    </fuse-alert>
    <fuse-alert
        class="my-4"
        *ngIf="showAlertEstatus"
        [dismissed]="!showAlertEstatus"
        [dismissible]="true"
        [appearance]="'outline'"
        [showIcon]="true"
        [type]="alertEstatus.type"
        [@shake]="alertEstatus.type === 'error'">
        {{ alertEstatus.message }}
    </fuse-alert>
    <fuse-alert
        class="my-4"
        *ngIf="showAlertEliminar"
        [dismissed]="!showAlertEliminar"
        [dismissible]="true"
        [appearance]="'outline'"
        [showIcon]="true"
        [type]="alertEliminar.type"
        [@shake]="alertEliminar.type === 'error'">
        {{ alertEliminar.message }}
    </fuse-alert>
    <fuse-alert
        class="my-4"
        *ngIf="showAlertDescargar"
        [dismissed]="!showAlertDescargar"
        [dismissible]="true"
        [appearance]="'outline'"
        [showIcon]="true"
        [type]="alertDescargar.type"
        [@shake]="alertDescargar.type === 'error'">
        {{ alertDescargar.message }}
    </fuse-alert>

    <div class="flex items-center justify-between mb-4">
        <div class="text-xl">Fianzas</div>
        <button mat-raised-button color="primary"
                *ngIf="canUpload()"
                (click)="openUploadDialog()">
            <mat-icon class="mr-2">upload_file</mat-icon>
            Cargar fianza
        </button>
    </div>

    <div class="overflow-auto">
        <table mat-table [dataSource]="fianzas">
            <ng-container matColumnDef="acciones">
                <th mat-header-cell *matHeaderCellDef>Acciones</th>
                <td mat-cell *matCellDef="let fianza">
                    <div class="flex flex-row gap-0">
                        <button mat-icon-button color="primary"
                                matTooltip="Descargar PDF"
                                (click)="descargarPdf(fianza.uuid)">
                            <mat-icon>download</mat-icon>
                        </button>
                        <button mat-icon-button color="primary"
                                *ngIf="canUpdateEstatus(fianza)"
                                matTooltip="Cambiar estatus"
                                (click)="openUpdateEstatusDialog(fianza)">
                            <mat-icon fontSet="material-symbols-outlined">check_circle</mat-icon>
                        </button>
                        <button mat-icon-button color="primary"
                                *ngIf="canEditAsMaster()"
                                matTooltip="Editar fianza"
                                (click)="openEditDialog(fianza)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button color="warn"
                                *ngIf="user?.rol === accountRole.master || canProviderDelete(fianza)"
                                matTooltip="Eliminar fianza"
                                (click)="eliminarFianza(fianza)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="numeroPoliza">
                <th mat-header-cell *matHeaderCellDef class="min-w-[120px]">Número de Póliza</th>
                <td mat-cell *matCellDef="let fianza" class="font-bold whitespace-nowrap">{{ fianza.numeroPoliza }}</td>
            </ng-container>

            <ng-container matColumnDef="companiaAfianzadora">
                <th mat-header-cell *matHeaderCellDef>Compañía Afianzadora</th>
                <td mat-cell *matCellDef="let fianza" class="whitespace-nowrap">{{ fianza.companiaAfianzadora }}</td>
            </ng-container>

            <ng-container matColumnDef="monto">
                <th mat-header-cell *matHeaderCellDef>Monto</th>
                <td mat-cell *matCellDef="let fianza" class="whitespace-nowrap">{{ fianza.monto | currency:'MXN':'symbol':'1.2-2':'es-MX' }}</td>
            </ng-container>

            <ng-container matColumnDef="fechaInicioVigencia">
                <th mat-header-cell *matHeaderCellDef>Inicio de Vigencia</th>
                <td mat-cell *matCellDef="let fianza" class="whitespace-nowrap">{{ fianza.fechaInicioVigencia | date:'dd/MM/yyyy' }}</td>
            </ng-container>

            <ng-container matColumnDef="fechaFinVigencia">
                <th mat-header-cell *matHeaderCellDef>Fin de Vigencia</th>
                <td mat-cell *matCellDef="let fianza" class="whitespace-nowrap">{{ fianza.fechaFinVigencia | date:'dd/MM/yyyy' }}</td>
            </ng-container>

            <ng-container matColumnDef="pagada">
                <th mat-header-cell *matHeaderCellDef>Pagada</th>
                <td mat-cell *matCellDef="let fianza">
                    <mat-icon [ngStyle]="{color: fianza.pagada ? '#18D25F' : '#9E9E9E'}">
                        {{ fianza.pagada ? 'check_circle' : 'cancel' }}
                    </mat-icon>
                </td>
            </ng-container>

            <ng-container matColumnDef="estatus">
                <th mat-header-cell *matHeaderCellDef>Estatus</th>
                <td mat-cell *matCellDef="let fianza" class="whitespace-nowrap">
                    <div class="flex items-center gap-2">
                        <span class="px-2 py-1 rounded-full text-xs font-bold"
                              [ngClass]="getEstatusClass(fianza.estatus)">
                            {{ getEstatusLabel(fianza.estatus) }}
                        </span>
                        <span *ngIf="fianza.proximaAVencer"
                              class="px-2 py-1 rounded-full text-xs font-bold bg-orange-100 text-orange-800"
                              matTooltip="Esta fianza vence pronto">
                            Próxima a vencer
                        </span>
                    </div>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td [colSpan]="displayedColumns.length" class="text-center py-8 text-secondary">
                    <mat-icon class="text-4xl mb-2 opacity-30">description</mat-icon>
                    <p>No hay fianzas registradas</p>
                </td>
            </tr>
        </table>
    </div>
</div>

<ng-template #uploadFianzaDialogTemplate>
    <h2 mat-dialog-title>{{ esEdicionMaster ? 'Editar Fianza' : 'Agregar Fianza' }}</h2>
    <mat-dialog-content>
        <form [formGroup]="uploadForm">
            <div class="grid grid-cols-2 gap-4 px-5 pt-4">
                <div>
                    <mat-form-field class="w-full">
                        <mat-label>Fianza .pdf</mat-label>
                        <ngx-mat-file-input formControlName="file" accept=".pdf" placeholder="Archivo de fianza">
                        </ngx-mat-file-input>
                        <mat-error *ngIf="uploadForm.controls['file'].hasError('required')">
                            El archivo es <strong>obligatorio</strong>
                        </mat-error>
                        <mat-error *ngIf="uploadForm.controls['file'].hasError('maxContentSize')">
                            El archivo no puede pesar más de
                            <strong>
                                {{ $safeNavigationMigration(uploadForm.controls['file'].errors?.maxContentSize.maxSize) | byteFormat }}
                                ({{ $safeNavigationMigration(uploadForm.controls['file'].errors?.maxContentSize.actualSize) | byteFormat }})
                            </strong>
                        </mat-error>
                        <mat-hint *ngIf="isExtractingPdf" class="flex items-center gap-1 text-primary">
                            <mat-spinner [diameter]="12"></mat-spinner>
                            Extrayendo datos del PDF…
                        </mat-hint>
                        <mat-hint *ngIf="!isExtractingPdf && camposAutocompletados === 5"
                                  class="text-green-600">
                            ✓ Información extraída del PDF correctamente
                        </mat-hint>
                        <mat-hint *ngIf="mostrarAvisoIncompleto"
                                  class="text-amber-600">
                            No fue posible obtener toda la información del documento. Le pedimos revisar y completar manualmente los campos faltantes.
                        </mat-hint>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field class="w-full">
                        <mat-label>Número de Póliza</mat-label>
                        <input matInput type="text" formControlName="numeroPoliza" placeholder="Número de póliza">
                        <mat-error *ngIf="uploadForm.get('numeroPoliza').hasError('required')">
                            El número de póliza es <strong>obligatorio</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field class="w-full">
                        <mat-label>Compañía Afianzadora</mat-label>
                        <input matInput type="text" formControlName="companiaAfianzadora" placeholder="Compañía afianzadora">
                        <mat-error *ngIf="uploadForm.get('companiaAfianzadora').hasError('required')">
                            La compañía afianzadora es <strong>obligatoria</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field class="w-full">
                        <mat-label>Monto</mat-label>
                        <input matInput type="text" formControlName="monto" placeholder="Monto de la fianza" currencyMask>
                        <mat-error *ngIf="uploadForm.get('monto').hasError('required')">
                            El monto es <strong>obligatorio</strong>
                        </mat-error>
                        <mat-error *ngIf="uploadForm.get('monto').hasError('min')">
                            El monto debe ser mayor a cero
                        </mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field class="w-full">
                        <mat-label>Inicio de Vigencia</mat-label>
                        <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="fechaInicio"
                               formControlName="fechaInicioVigencia" placeholder="Fecha de inicio de vigencia">
                        <mat-datepicker-toggle matSuffix [for]="fechaInicio"></mat-datepicker-toggle>
                        <mat-datepicker #fechaInicio></mat-datepicker>
                        <mat-hint>DD/MM/AAAA</mat-hint>
                        <mat-error *ngIf="uploadForm.get('fechaInicioVigencia').hasError('required')">
                            La fecha de inicio es <strong>obligatoria</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field class="w-full">
                        <mat-label>Fin de Vigencia</mat-label>
                        <input matInput [min]="minDate" [max]="maxDate" [matDatepicker]="fechaFin"
                               formControlName="fechaFinVigencia" placeholder="Fecha de fin de vigencia">
                        <mat-datepicker-toggle matSuffix [for]="fechaFin"></mat-datepicker-toggle>
                        <mat-datepicker #fechaFin></mat-datepicker>
                        <mat-hint>DD/MM/AAAA</mat-hint>
                        <mat-error *ngIf="uploadForm.get('fechaFinVigencia').hasError('required')">
                            La fecha de fin es <strong>obligatoria</strong>
                        </mat-error>
                    </mat-form-field>
                    <mat-error *ngIf="isDateRangeInvalid">
                        La fecha de fin debe ser posterior a la fecha de inicio.
                    </mat-error>
                </div>
                <div class="col-span-2">
                    <mat-form-field class="w-full">
                        <mat-label>Objeto</mat-label>
                        <textarea matInput formControlName="objeto" placeholder="Objeto de la fianza" rows="3"></textarea>
                        <mat-error *ngIf="uploadForm.get('objeto').hasError('required')">
                            El objeto es <strong>obligatorio</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div class="flex items-center">
                    <mat-checkbox formControlName="pagada" color="primary">Pagada</mat-checkbox>
                </div>
            </div>
        </form>
        <div class="fixed inset-0 flex justify-center items-center bg-black bg-opacity-5 z-50" *ngIf="isSubmitting">
            <mat-spinner [diameter]="60"></mat-spinner>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button class="ml-auto" mat-button (click)="_uploadDialogRef?.close()">
            Cancelar
        </button>
        <button class="ml-2" color="primary" mat-flat-button
                [disabled]="uploadForm.invalid || isSubmitting" (click)="uploadFianza()">
            {{ isSubmitting ? 'Guardando...' : 'Guardar' }}
        </button>
    </mat-dialog-actions>
</ng-template>

<ng-template #updateEstatusDialogTemplate>
    <h2 mat-dialog-title>Cambiar Estatus de Fianza</h2>
    <mat-dialog-content>
        <form [formGroup]="updateEstatusForm">
            <div class="grid grid-cols-1 gap-4 px-5">
                <div>
                    <mat-form-field class="w-full">
                        <mat-label>Estatus</mat-label>
                        <mat-select formControlName="estatus" placeholder="Selecciona un estatus">
                            <mat-option value="ACEPTADA_VIGENTE">Aceptada / Vigente</mat-option>
                            <mat-option value="RECHAZADA">Rechazada</mat-option>
                        </mat-select>
                        <mat-error *ngIf="updateEstatusForm.get('estatus').hasError('required')">
                            El estatus es <strong>obligatorio</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
                <div *ngIf="showMotivoRechazo">
                    <mat-form-field class="w-full">
                        <mat-label>Motivo de Rechazo</mat-label>
                        <textarea matInput formControlName="motivoRechazo"
                                  placeholder="Indica el motivo del rechazo" rows="3"></textarea>
                        <mat-error *ngIf="updateEstatusForm.get('motivoRechazo').hasError('required')">
                            El motivo de rechazo es <strong>obligatorio</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
        <div class="fixed inset-0 flex justify-center items-center bg-black bg-opacity-5 z-50" *ngIf="isSubmitting">
            <mat-spinner [diameter]="60"></mat-spinner>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button class="ml-auto" mat-button (click)="_updateEstatusDialogRef?.close()">
            Cancelar
        </button>
        <button class="ml-2" color="primary" mat-flat-button
                [disabled]="updateEstatusForm.invalid || isSubmitting" (click)="actualizarEstatus()">
            {{ isSubmitting ? 'Guardando...' : 'Guardar' }}
        </button>
    </mat-dialog-actions>
</ng-template>
